import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/site/Motion";

const REVIEWS = [
  { quote: "Switching cut the fees out of our day-to-day and our account manager set everything up for us.", name: "Maria", biz: "Restaurant Owner" },
  { quote: "When our terminal had an issue on a Saturday, tech support had us running again in minutes.", name: "James", biz: "Auto Repair Shop Owner" },
  { quote: "No surprises on the statement. Everything was explained up front, in plain English.", name: "Tanya", biz: "Salon Owner" },
];

export const Testimonials = () => (
  <section id="reviews" className="relative bg-[#EAF3FF] px-4 py-24 sm:px-6 lg:px-12 lg:py-32" data-testid="testimonials-section">
    <div className="mx-auto max-w-7xl">
      <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end">
        <Reveal>
          <Eyebrow>What our clients say</Eyebrow>
          <h2 className="mt-4 max-w-2xl font-display text-4xl font-extrabold leading-[1.02] tracking-tight text-[#050B1F] sm:text-5xl lg:text-6xl">
            Merchants who <span className="italic text-emerald-600">switched</span> to zero.
          </h2>
        </Reveal>
        <Reveal delay={0.1}><p className="max-w-sm text-emerald-950/75">Here's what it's like to have a processing partner in your corner.</p></Reveal>
      </div>
      <div className="mt-14 grid gap-6 md:grid-cols-3">
        {REVIEWS.map((r, i) => (
          <Reveal key={i} delay={i * 0.1}>
            <motion.figure whileHover={{ y: -8 }} transition={{ type: "spring", stiffness: 260, damping: 20 }} data-testid={`testimonial-card-${i}`}
              className={`flex h-full flex-col justify-between rounded-3xl p-8 ${i === 1 ? "bg-[#0B2A6F] text-white" : "border border-emerald-900/10 bg-white text-[#050B1F]"}`}>
              <div>
                <Quote className={`h-9 w-9 ${i === 1 ? "text-lime-400" : "text-emerald-600"}`} />
                <blockquote className="mt-6 font-display text-xl font-bold leading-snug tracking-tight sm:text-2xl">"{r.quote}"</blockquote>
              </div>
              <figcaption className="mt-10 flex items-center gap-4">
                <span className={`grid h-12 w-12 place-items-center rounded-full font-display text-lg font-extrabold ${i === 1 ? "bg-lime-400 text-[#050B1F]" : "bg-[#0B2A6F] text-lime-300"}`}>{r.name[0]}</span>
                <div>
                  <p className="font-semibold">{r.name}</p>
                  <p className={`text-sm ${i === 1 ? "text-emerald-100/80" : "text-emerald-900/70"}`}>{r.biz}</p>
                </div>
              </figcaption>
            </motion.figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
